import React from 'react';
import { ChevronRight } from 'lucide-react';

export const SkewButton = ({ 
  children, 
  variant = 'primary', 
  onClick, 
  href, 
  className = '',
  icon = true,
  testId = 'skew-button'
}) => {
  const baseStyles = "inline-flex items-center gap-2 px-6 py-3 font-oswald font-bold uppercase tracking-wider transition-all duration-300 skew-btn";
  
  const variants = {
    primary: "bg-brand-lime text-brand-black hover:bg-brand-pink hover:text-white",
    secondary: "border-2 border-brand-pink text-brand-pink hover:bg-brand-pink hover:text-white",
    outline: "border-2 border-brand-lime text-brand-lime hover:bg-brand-lime hover:text-brand-black",
    ghost: "text-white hover:text-brand-lime"
  };

  const content = (
    <>
      <span className="transform skewX-10">{children}</span>
      {icon && <ChevronRight size={18} className="transform skewX-10" />}
    </>
  );

  if (href) {
    return (
      <a 
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={testId}
        className={`${baseStyles} ${variants[variant]} ${className}`}
      >
        {content}
      </a>
    );
  }

  return (
    <button 
      onClick={onClick}
      data-testid={testId}
      className={`${baseStyles} ${variants[variant]} ${className}`}
    >
      {content}
    </button>
  );
};

export const SectionTitle = ({ 
  title, 
  subtitle, 
  accent = 'lime',
  align = 'left',
  className = '' 
}) => {
  const alignClasses = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right'
  };

  return (
    <div className={`${alignClasses[align]} ${className}`}>
      {subtitle && (
        <p className={`font-oswald text-sm uppercase tracking-[0.3em] mb-2 ${accent === 'lime' ? 'text-brand-lime' : 'text-brand-pink'}`}>
          {subtitle}
        </p>
      )}
      <h2 className="font-oswald text-4xl md:text-6xl font-bold uppercase tracking-tight text-white">
        {title}
      </h2>
    </div>
  );
};

export const Card = ({ 
  children, 
  className = '',
  hover = true,
  testId = 'card'
}) => {
  return (
    <div 
      data-testid={testId}
      className={`bg-brand-dark border border-white/10 ${hover ? 'hover:border-brand-lime/50 hover:translate-y-[-4px] hover:shadow-[0_0_20px_rgba(50,205,50,0.2)]' : ''} transition-all duration-300 ${className}`}
    >
      {children}
    </div>
  );
};

export const GradientDivider = () => (
  <div className="h-1 w-32 bg-gradient-to-r from-brand-lime to-brand-pink" />
);
